/**
 * Import Wizard Vuex store module for managing import process state and navigation
 */
import { getField, updateField } from 'vuex-map-fields'

export const state = () => ({
    currentStep: 1,
    steps: [
            { number: 1, name: 'Upload', component: 'UploadStep', completed: false },
            { number: 2, name: 'Field Mapping', component: 'FieldMappingStep', completed: false },
            { number: 3, name: 'Details', component: 'DetailsStep', completed: false }
    ],
    uploadedFile: null,
    fieldMapping: {},
    importDetails: {},
    rows: [],
    importFileId: null,
    totalRows: null,
    availableQuota: null,
    isLimitApplies: false,
    headerRow: true,
    isStepCompleted: false,
    mappingHasAgent: false,
    mappingHasMortgage: false,
    mappingHasTags: false,
    mappingHasType: false,
    fields: [],
    admins: [],
    mortgage: [],
    teams: [],
    groups: [],
    defAssignment: null,
    isPPCANDNotAdministrator: false,
    groupOption: [
        { 'label' : 'Do not put leads in a pipeline', 'value' : '-nopipeline-' },
        { 'label' : 'Put leads in selected pipeline', 'value' : '-man-' },
        { 'label' : 'Put leads in a pipeline based on their type', 'value' : '-nogroup-' }
    ],
    tagOption: [{ 'label' : 'Do not tag', 'value' : '-notags-' }, {'label' : 'Manually tag', 'value' : '-mantag-'}],
    leadTypeOption: [{ 'label' : 'Buyer', 'value' : 'buyer' }, {'label' : 'Seller', 'value' : 'seller'}, {'label' : 'Buyer / Seller', 'value' : 'buyer / seller'}, {'label' : 'Renter', 'value' : 'renter'}, {'label' : 'Commission Share', 'value' : 'mlm'}, {'label' : 'Unspecified', 'value' : 'unknown'}]
})

export const mutations = {
    updateField,
    setStepCompleted(state, { stepNumber, completed }) {
        let step = state.steps.find(step => step.number === stepNumber)
        if(!step) return;
        step.completed = completed
    },
    initWizardData(state, payload) {
        // Only assign properties that should be part of the state
        const allowedFields = [
            'fields', 'admins', 'mortgage', 'teams', 'groups', 
            'defAssignment', 'isPPCANDNotAdministrator'
        ]
        
        allowedFields.forEach(field => {
            if (payload.hasOwnProperty(field)) {
                state[field] = payload[field]
            }
        })
    }
}

export const getters = {
    getField,
    currentStepInfo: state => state.steps.find(step => step.number === state.currentStep)
}